<nav class="navbar navbar-expand-lg navbar-dark bg-dark" *ngIf="account$ | async as account">
  <div class="container-fluid">
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#homeNavigation"
      aria-controls="homeNavigation"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <a class="navbar-brand" [routerLink]="['/']"
      ><img src="/assets/favicon-32x32.png" alt="Klubbavgift.se's logo" /><span class="align-middle ms-2">Klubbavgift.se</span></a
    >
    <div class="collapse navbar-collapse" id="homeNavigation">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item py-2 py-sm-0" *ngIf="organizations$ | async as organizations">
          <div ngbDropdown class="d-inline-block">
            <a class="nav-link" id="dropdownBasic1" ngbDropdownToggle
              ><span class="material-icons-outlined align-middle d-inline d-lg-none d-xl-inline">hub</span>
              <span class="align-middle ms-1">Organisationer</span>
            </a>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <ng-container *ngFor="let organization of organizations">
                <button *ngIf="organization.verified" ngbDropdownItem [routerLink]="['organization', organization.id]">
                  <img
                    *ngIf="organization.logoUrl"
                    style="width: 24px"
                    class="mx-2 d-inline d-sm-inline"
                    [src]="organization.logoUrl"
                    alt="{{ organization.name }}'s logo" />
                  {{ organization.name }}<small *ngIf="!organization.verified"> (Väntande)</small>
                </button>

                <span *ngIf="!organization.verified" ngbDropdownItem [ngClass]="{ 'fst-italic': !organization.verified }">
                  {{ organization.name }}<small *ngIf="!organization.verified"> (Väntande)</small>
                </span>
              </ng-container>

              <li *ngIf="organizations && organizations.length > 0">
                <hr class="dropdown-divider" />
              </li>
              <button ngbDropdownItem [routerLink]="['organization/search']">
                <span class="material-icons">search</span>Sök organisation
              </button>
              <button ngbDropdownItem [routerLink]="['organization/register']">
                <span class="material-icons">add</span>Registrera ny organisation
              </button>
            </div>
          </div>
        </li>
        <li class="nav-item py-2 py-sm-0" *ngIf="account.superAdmin">
          <a
            class="nav-link position-relative"
            data-bs-toggle="collapse"
            data-bs-target=".navbar-collapse.show"
            routerLinkActive="active"
            [routerLink]="['admin']"
            ><span class="material-icons align-middle d-inline d-lg-none d-xl-inline">admin_panel_settings</span
            ><span class="align-middle ms-1">Superadmin</span></a
          >
        </li>
        <li class="nav-item py-2 py-sm-0 d-inline d-lg-none">
          <app-support-icon [renderAsMenuOption]="true"></app-support-icon>
        </li>
      </ul>
      <app-support-icon class="me-3 d-none d-lg-inline" [renderAsMenuOption]="false"></app-support-icon>
      <app-account class="me-2"></app-account>
    </div>
  </div>
</nav>
